import { render, staticRenderFns } from "./VeJwCjChangeList.vue?vue&type=template&id=7bb764a8&scoped=true"
import script from "./VeJwCjChangeList.vue?vue&type=script&lang=js"
export * from "./VeJwCjChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb764a8",
  null
  
)

export default component.exports